import { render } from "./Background.vue?vue&type=template&id=66818b9a"
import script from "./Background.vue?vue&type=script&lang=ts"
export * from "./Background.vue?vue&type=script&lang=ts"

import "./Background.vue?vue&type=style&index=0&id=66818b9a&lang=scss"
script.render = render

export default script